var _defs, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyFrameBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "checkerboard",
    x: 0,
    y: 0,
    width: 16,
    height: 16,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 8,
    height: 8,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 0,
    width: 8,
    height: 8,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 8,
    width: 8,
    height: 8,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 8,
    height: 8,
    fill: "#D9D9D9"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "url(#checkerboard)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyFrameBg);
export default __webpack_public_path__ + "static/media/empty_frame_bg.8ead6817448b3ea7cffa34e99dba1890.svg";
export { ForwardRef as ReactComponent };